import {isCorrectAnswer} from "../../../Tools";

function FinalGrid({ step, questions, goToQuestion }) {
    return (
        <ul className="exam-sim-question-grid-items final-grid">
            {questions.map((q, idx) => {
                let classes = []
                if(!isCorrectAnswer(q))
                    classes.push('failed')

                return <li key={idx} className={classes.join(' ')}>
                    <button type="button" onClick={() => goToQuestion(idx, step)}>{idx + 1}</button>
                </li>
            })}
        </ul>
    );
}

export default FinalGrid;
